import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import Datasheet from "react-datasheet";
import { 
    OrderedMap, 
    // List
} from "immutable";
import {
    ObjectSelectEditor
} from "components";
import { Button } from "antd";
import { UI_LIST_ITEM_TYPES } from "constants";
import { RAISE_RFF_TYPES } from "constants/enums";
// import DatasheetSelectEditor from "components/datasheet-select-editor";

// const valueRenderer = (_, key, type) => {
//     return _ && (type && _[key] ? _[key].toFixed(2) : _[key]);
// };

const BUSINESS_DATASHEET_FIELDS = () => new OrderedMap({
    labels: {
        label: "Schemes",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM_HEADER,
        // render: valueRenderer
    },
    program_size: {
        label: "Program Size",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "FLOAT",
        // render: valueRenderer
    },
    limit_max: {
        label: "Max Limit",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "FLOAT",
        // render: valueRenderer
    },
    min_limit: {
        label: "Min Limit",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "FLOAT",
        // render: valueRenderer
    },
    raise_rff: {
        label: "Raise RFF",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: RAISE_RFF_TYPES,
        // render: valueRenderer,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={RAISE_RFF_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    mode={"multiple"}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    }
});


class BusinessBasicDetailsForm extends React.Component{
    state = {
        masterProgramData: [],
        distributorProgramData: [],
        basicDetails: null
    };
    edit = true;
    fields = null;

    generateDetailRows(isMPA) {
        this.fields = BUSINESS_DATASHEET_FIELDS();
        let grid_header = this.fields.map((_, k) => {
            if (_.type === UI_LIST_ITEM_TYPES.SECTION) {
                return [
                    {
                        value: _.label,
                        readOnly: true,
                        itemKey: k,
                        type: _.type,
                        colSpan: this.fields && this.fields.size
                    }
                ];
            }
            return ({
                value: _.label,
                readOnly: true,
                colSpan: 1,
                type: _.type,
                itemKey: k
            });
        }).toList().toArray();

        let grid_content = [
            {
                value: isMPA ? "Master Program" : "Distributor Program",
                readOnly: true,
                type: "LIST_ITEM_HEADER"
            },
            ...this.fields.filter(_ => !["SECTION", "LIST_ITEM_HEADER"].includes(_.type)).map((_,k) => ({
                value: this.props.parentProgramData && isMPA ? 
                    this.props.parentProgramData[k] : 
                    this.props.values && this.props.values[k] ?
                        this.props.values[k] : null,
                itemKey: k,
                type: _.type,
                readOnly: this.props.parentProgramData && isMPA ? true : false,
                dataType: _.dataType,
                options: _.options,
                dataEditor: _.component
            })).toList().toArray()
        ];
        let grid_data = [grid_header, grid_content];
        return grid_data;
    }

    componentDidMount() {
        this.edit = true;
        this.setState({
            masterProgramData: this.generateDetailRows(true),
            distributorProgramData: this.props.parentProgramData ? this.generateDetailRows(false) : []
        });
    }

    cellRenderer = (cell) => {
        if(cell && cell.dataType === "SELECT") {
            return cell.value ? cell.options.findKey(_ => _ === cell.value) : "";
        }
        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && (cell.value.name || cell.value.label )) {
            return cell.value ? (cell.value.name ? cell.value.name : cell.value.label) : "";
        }

        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && typeof cell.value !== "string" && cell.value.length > 0) {
            return cell.value ? (cell.value.map(_ => _.name ? _.name : _.label).join("; ")) : "";
        }

        if(cell.value && cell.value._isAMomentObject) {
            return cell.value.format("DD-MM-YYYY");
        }

        if(cell.value && isNaN(cell.value)) {
            return cell.value;
        }
        if(!cell.value) {
            return "--";
        }
        return cell.value;
    }

    handleCellsChanged = (changes) => {
        this.edit = true;
        this.saveActive = true;
        const grid = this.state.distributorProgramData.map(row => [...row]);
        changes.forEach(({ row, col, value }) => {
            let error = false;
            // if (
            //     value &&
            //     isNaN(Number(value)) &&
            //     value.length > 0
            // ) {
            //     error = true;
            //     this.saveActive = false;
            // }
            grid[row][col] = {
                ...grid[row][col],
                value,
                className: error ? "error-cell" : null
            };
        });
        this.setState({ distributorProgramData: grid });
    }

    saveBasicDetails = () => {
        const obj = {};
        if(this.state.distributorProgramData && this.state.distributorProgramData.length > 0 && this.props.parentProgramData && this.props.parentProgramData.id) {
            this.state.distributorProgramData[1]
                .filter(_ => _.type === UI_LIST_ITEM_TYPES.LIST_ITEM)
                .map((v) => {
                    obj[v.itemKey] = typeof v.value === "object" ? 
                        (v.value.length > 0 ? v.value.map(_ => (_.label || _.value || _.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) : 
                    
                        v.value === "" ? 0 : 
                            typeof v.value === "string" ? 
                                v.value : Number(v.value);
                });
        }
        else {
            this.state.masterProgramData[1]
                .filter(_ => _.type === UI_LIST_ITEM_TYPES.LIST_ITEM)
                .map((v) => {
                    obj[v.itemKey] = typeof v.value === "object" ? 
                        (v.value.length > 0 ? v.value.map(_ => (_.value || _.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) :                   
                        v.value === "" ? 0 : 
                            typeof v.value === "string" ? 
                                v.value : Number(v.value);
                });
        }

        let newObj = {
            ...obj,
            business_program: this.props.businessProgramId
        };
        this.props.saveBasicDetails(newObj);
    }

    render() {
        return (
            <React.Fragment>
                <div className={"d-flex"}>
                    <div className={this.props.parentProgramData ? "m-5 spreadsheet-table business-program" : "m-5 spreadsheet-table"}>
                        <Datasheet
                            data={this.state.masterProgramData}
                            valueRenderer={cell =>
                                this.cellRenderer(cell)
                            }
                            onCellsChanged={(changes) => {
                                this.edit = true;
                                this.saveActive = true;
                                const grid = this.state.masterProgramData.map(row => [...row]);
                                changes.forEach(({ row, col, value }) => {
                                    let error = false;
                                    // if (
                                    //     value &&
                                    //     isNaN(Number(value)) &&
                                    //     value.length > 0
                                    // ) {
                                    //     error = true;
                                    //     this.saveActive = false;
                                    // }
                                    grid[row][col] = {
                                        ...grid[row][col],
                                        value,
                                        className: error ? "error-cell" : null
                                    };
                                });
                                this.setState({ masterProgramData: grid });
                            }}
                        />
                    </div>
                    {this.props.parentProgramData ? (
                        <div className={"m-5 spreadsheet-table business-program"}>
                            <Datasheet
                                data={this.state.distributorProgramData}
                                valueRenderer={cell =>
                                    this.cellRenderer(cell)
                                }
                                onCellsChanged={(changes) => {
                                    this.edit = true;
                                    this.saveActive = true;
                                    const grid = this.state.distributorProgramData.map(row => [...row]);
                                    changes.forEach(({ row, col, value }) => {
                                        let error = false;
                                        // if (
                                        //     value &&
                                        //     isNaN(Number(value)) &&
                                        //     value.length > 0
                                        // ) {
                                        //     error = true;
                                        //     this.saveActive = false;
                                        // }
                                        grid[row][col] = {
                                            ...grid[row][col],
                                            value,
                                            className: error ? "error-cell" : null
                                        };
                                    });
                                    this.setState({ distributorProgramData: grid });
                                }}
                            />
                        </div>
                    ) : null}
                </div>
                <div className="d-flex justify-content-flex-end mr-5" style={{paddingTop: "5px"}}>
                    <Button key="save" type="primary" icon={"plus"} onClick={this.saveBasicDetails}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                </div>
            </React.Fragment>
        );
    }
}

BusinessBasicDetailsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    saveBasicDetails: PropTypes.func,
    updateBasicDetails: PropTypes.func,
    businessProgramId: PropTypes.number,
    parentProgramData: PropTypes.object

};

export default BusinessBasicDetailsForm;